
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 600 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-mercury",attrs:{"stroke":"#00B3AB","stroke-dasharray":"15 20","stroke-width":"1.5","d":"M94.75 454.724a257.03 257.03 0 0 1-42.837-221.952 257.04 257.04 0 0 1 263.424-189.35A257.03 257.03 0 0 1 512.066 154.76a257.04 257.04 0 0 1 42.264 108.046"}}),_c('path',{staticClass:"i-venus",attrs:{"stroke":"#D0EFEC","stroke-width":"30","d":"M144.223 496.786a251 251 0 0 1-87.68-135.793"}})])
          )
        }
      }
    